module.exports = __webpack_public_path__ + "static/media/link-icon.6861b4d5.svg";